import React, {
  useState,
  Fragment,
  useRef,
  useEffect,
} from 'react';
import Fade from 'react-reveal/Fade';
import Childs from '../Childs/Level_9_Childs';

// import MedicineDelivery from './MedicineDelivery';

const Level9 = (props) => {
  const { options } = props;
  const [id, setId] = useState(0);
  const [showBot, toggleBot] = useState(false);
  const messageEndRef = useRef(null);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [options])

  return (
    <div className="options">
      <div className="options-container">
        {options.map((option) => {
          return (
            <Fragment>
              {
                option.isOtherSource === true ? (
                  <a
                    className="option-item"
                    href={option.url}
                    name="link"
                    aria-label="link"
                    key={option.id}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {option.name}
                  </a>
                ) : (
                  <div
                    aria-hidden="true"
                    className="option-item"
                    onClick={
                      () => {
                        setId(option.id);
                        toggleBot(true);
                      }
                    }
                    key={option.id}
                  >
                    {option.name}
                  </div>
                )
              }
            </Fragment>
          );
        })}
        {
          showBot && (
            <Fade big>
              <Childs id={id} />
              {/* <MedicineDelivery id={id} /> */}
            </Fade>
          )
        }
        <div ref={messageEndRef} />
      </div>
      {/* <MedicineDelivery id={id} /> */}
    </div>
  );
};

export default Level9;
